import React, { useContext } from 'react';
import { OrderExportConfigurationContext } from '../../../../../../context/OrderExportConfigurationContext';
import { ExportConfigurationsPane } from '../../../../../components/ExportItems';

export default function OrderExportConfigurationsPane() {
  const { orderExportConfigurations, orderExportConfigurationsLoading } = useContext(OrderExportConfigurationContext);
  return (
    <ExportConfigurationsPane
      configurations={[...orderExportConfigurations.values()]}
      loading={orderExportConfigurationsLoading}
    />
  );
}
